module.exports = __webpack_public_path__ + "618efca44103d82566e5c20c9838fd09.svg";